export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40a4b20614fc9f8c068c7e530b0d21dd99c63312e1&name=revalidateCommunity!'